import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Avatar from 'react-toolbox/lib/avatar'
import Chip from 'react-toolbox/lib/chip'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import {
  compose,
  branch,
  withProps,
  renderComponent,
} from 'recompose'

import {
  GREENLIGHT_STATES
} from './constants'

import Body from 'components/typography/body2/index'

import styles from './styles.scss'

const ApprovedChip = props => {
  return (
    <Chip
      deletable={props.deletable}
      theme={styles}
    >
      <Avatar theme={styles} icon='check'/>
      <Body theme={styles}>
        {T.translate('containers.project.greenlightReport.revision.approved')}
      </Body>
    </Chip>
  )
}

const RejectedChip = props => {
  return (
    <Chip
      styleName='rejected'
      deletable={props.deletable}
      theme={styles}
    >
      <Avatar theme={styles} icon='close'/>
      <Body theme={styles}>
        {T.translate('containers.project.greenlightReport.revision.rejected')}
      </Body>
    </Chip>
  )
}

const withStyle = CSSModules(styles)
const ApprovalChip = compose(
  branch(
    ({ status }) => status === GREENLIGHT_STATES.APPROVED,
    compose(
      renderComponent,
      withStyle,
    )(ApprovedChip)
  ),
  withStyle
)(RejectedChip)

ApprovalChip.propTypes = {
  deletable: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired
}

ApprovalChip.defaultProps = {
  deletable: false,
  status: GREENLIGHT_STATES.REJECTED
}

export default withStyle(ApprovalChip)
